module.exports = __webpack_public_path__ + "assets/images/0a244723c6d8ec5a0250d57c362233a9.svg";